// platform/src/models/WorkOrders.js
import Model from './Model';

class WorkOrders extends Model{

    static getCorrigoWorkOrdersByProperty = async (property_external_uuid) => {
        console.log(`getCorrigoWorkOrdersByProperty: Fetching work orders for property: ${property_external_uuid}`);
        
        const res = await this.runQuery(GetCorrigoWorkOrdersByProperty, { property_external_uuid });

        console.log("getCorrigoWorkOrdersByProperty: Query result:", res);
        return res.data.getCorrigoWorkOrdersByProperty;
    };


    static getAllCorrigoWorkOrders = async (limit = 100, offset = 0) => {
        console.log(`getAllCorrigoWorkOrders: Fetching with limit ${limit} and offset ${offset}...`);
        const res = await this.runQuery(GetAllCorrigoWorkOrders, { limit, offset });
        console.log("getAllCorrigoWorkOrders: Query result:", res);
        return res.data.getAllCorrigoWorkOrders;
    }

    static getAllCorrigoDSTWorkOrders = async () => {
        console.log("getAllCorrigoDSTWorkOrders: Starting query...");
        const res = await this.runQuery(GetAllCorrigoDSTWorkOrders);
        console.log("getAllCorrigoDSTWorkOrders: Query result:", res);
        return res.data.getAllCorrigoDSTWorkOrders;
    }

    static filterBy = async (searchList = [], sortField = "dt_created", sortOrder = "desc", first, after, last, before, ignoreCache = false) => {
        const data = await super.filterBy(CorrigoWorkOrderFilter, searchList, sortField, sortOrder, first, after, last, before, ignoreCache);

        const result = data && data.corrigoWorkOrderFilter;

        const formattedData = {
            data: result && (result.edges || []).map(e => e.node),
            pageInfo: result && result.pageInfo
        };

        console.log("WorkOrders.filterBy: Formatted data to return:", formattedData);
        return formattedData;
    };

    static getWorkOrderIdsByDateRange = async (startDate, endDate) => {
        console.log(`getWorkOrderIdsByDateRange: Fetching work order IDs between ${startDate} and ${endDate}...`);
        
        const res = await this.runQuery(GetWorkOrderIdsByDateRange, { startDate, endDate });
        
        console.log("getWorkOrderIdsByDateRange: Query result:", res);
        return res.data.getWorkOrderIdsByDateRange;
    };

    /**
     * Update the validation value for a work order
     * @param {string|number} workOrderId - The work order ID to update
     * @param {number} validation - The validation value
     * @returns {Promise<boolean>} - Resolves with success status
     */
    static updateWorkOrderVal = async (workOrderId, validation) => {
        console.log(`updateWorkOrderVal: Updating validation for work order ${workOrderId} to ${validation}`);
        
        if (!workOrderId) {
            console.error('Work order ID is required');
            throw new Error('Work order ID is required');
        }
        
        const res = await this.runQuery(UpdateWorkOrderVal, { 
            work_order_id: workOrderId, 
            validation: Number(validation) 
        });
        
        console.log("updateWorkOrderVal: Mutation result:", res);
        return res.data.updateWorkOrderVal;
    };

    /**
     * Update the asset value for a work order
     * @param {string|number} workOrderId - The work order ID to update
     * @param {number} asset - The asset value
     * @returns {Promise<boolean>} - Resolves with success status
     */
    static updateWorkOrderAsset = async (workOrderId, asset) => {
        console.log(`updateWorkOrderAsset: Updating asset for work order ${workOrderId} to ${asset}`);
        
        if (!workOrderId) {
            console.error('Work order ID is required');
            throw new Error('Work order ID is required');
        }
        
        const res = await this.runQuery(UpdateWorkOrderAsset, { 
            work_order_id: workOrderId, 
            asset: Number(asset) 
        });
        
        console.log("updateWorkOrderAsset: Mutation result:", res);
        return res.data.updateWorkOrderAsset;
    };

    /**
     * Update the avoid value for a work order
     * @param {string|number} workOrderId - The work order ID to update
     * @param {number} avoid - The avoid value
     * @returns {Promise<boolean>} - Resolves with success status
     */
    static updateWorkOrderAvoid = async (workOrderId, avoid) => {
        console.log(`updateWorkOrderAvoid: Updating avoid for work order ${workOrderId} to ${avoid}`);
        
        if (!workOrderId) {
            console.error('Work order ID is required');
            throw new Error('Work order ID is required');
        }
        
        const res = await this.runQuery(UpdateWorkOrderAvoid, { 
            work_order_id: workOrderId, 
            avoid: Number(avoid) 
        });
        
        console.log("updateWorkOrderAvoid: Mutation result:", res);
        return res.data.updateWorkOrderAvoid;
    };

}

const GetAllCorrigoWorkOrders = `
query GetAllCorrigoWorkOrders($limit: Int, $offset: Int) {
    getAllCorrigoWorkOrders(limit: $limit, offset: $offset) {
        id
        work_order_id
        uuid
        number
        x_number
        type_category
        work_order_cost_id
        priority_id
        priority
        status_id
        requestor_contact_id
        access
        main_asset_id
        short_location
        task_refinement
        work_zone_id
        employee_id
        duration
        address_id
        bill_to_type
        bill_to_option_id
        vendor_nte_currency
        vendor_nte_value
        specialty_id
        po_number
        sub_type_id
        repair_code_id
        customer_id
        customer_nte_currency
        customer_nte_value
        billing_rule
        costs_total_value
        costs_total_currency
        vendor_invoice_total_value
        vendor_invoice_total_currency
        expenses_total_value
        expenses_total_currency
        service_fees_total_value
        service_fees_total_currency
        contact_name
        contact_address_id
        won_id
        dt_scheduled_start
        scheduled_start_utc
        is_warranty
        flag_id
        time_zone
        currency_type_id
        bill_status
        ap_state_id
        ap_status_id
        is_pre_billed
        cost_state
        cost_status_id
        job_code
        authorization_code
        check_number
        payment_amount_value
        payment_amount_currency
        payment_notes
        check_cut_date
        check_clear_date
        vendor_invoice_date
        vendor_invoice_received_date
        wo_items_sort_order_idx
        wo_items_asset_location
        wo_items_asset_id
        wo_items_task_id
        wo_items_comment
        equipment_asset_id
        equipment_comment
        equipment_refrigerant_used
        equipment_type
        procedure_template_id
        procedure_asset_id
        procedure_type
        procedure_allow_mark_all
        procedure_allow_not_applicable
        procedure_is_not_applicable
        procedure_flag_id
        procedure_status_id
        procedure_index
        financial_items
        quote_items
        estimate_items
        action_logs
        last_action_date
        dt_created
        dt_due
        dt_acknowledge_by
        acknowledge_by_utc
        last_action_date_utc
        created_date_utc
        due_date_utc
        dt_on_site_by
        dt_utc_on_site_by
        last_action_id
        induction_and_safety_status_id
        concurrency_id
        owner_id
        evaluation_ids_while_open
        latest_evaluation_id_after_closed
        source_company_id
        note_text
        completion_note_text
        raw_workorder_response
        created_at
        updated_at
        property_number
        assignee_screen_name
        failure_code
        created_by_name
        subtype_name
        failure_category
        total_spot_cost
        is_dst
        root_comp
        source
        validation
        asset
        avoid
        property_uuid
        compressor_failure_detected
        compressor_failure_confidence
        compressor_failure_reasoning
        llm_last_analyzed
        llm_suggested_asset
        llm_suggested_validation
        llm_classification_confidence
        llm_classification_reasoning
    }
}`;

const GetAllCorrigoDSTWorkOrders = `
query GetAllCorrigoDSTWorkOrders {
    getAllCorrigoDSTWorkOrders {
        id
        uuid
        number
        typeCategory
        statusId
        createdAt
        updatedAt
        customerId
        isWarranty
        totalSpotCost
    }
}`;


const GetCorrigoWorkOrdersByProperty = `
query GetCorrigoWorkOrdersByProperty($property_external_uuid: String!) {
    getCorrigoWorkOrdersByProperty(property_external_uuid: $property_external_uuid) {
        id
        work_order_id
        uuid
        number
        x_number
        type_category
        work_order_cost_id
        priority_id
        priority
        status_id
        requestor_contact_id
        access
        main_asset_id
        short_location
        task_refinement
        work_zone_id
        employee_id
        duration
        address_id
        bill_to_type
        bill_to_option_id
        vendor_nte_currency
        vendor_nte_value
        specialty_id
        po_number
        sub_type_id
        repair_code_id
        customer_id
        customer_nte_currency
        customer_nte_value
        billing_rule
        costs_total_value
        costs_total_currency
        vendor_invoice_total_value
        vendor_invoice_total_currency
        expenses_total_value
        expenses_total_currency
        service_fees_total_value
        service_fees_total_currency
        contact_name
        contact_address_id
        won_id
        dt_scheduled_start
        scheduled_start_utc
        is_warranty
        flag_id
        time_zone
        currency_type_id
        bill_status
        ap_state_id
        ap_status_id
        is_pre_billed
        cost_state
        cost_status_id
        job_code
        authorization_code
        check_number
        payment_amount_value
        payment_amount_currency
        payment_notes
        check_cut_date
        check_clear_date
        vendor_invoice_date
        vendor_invoice_received_date
        wo_items_sort_order_idx
        wo_items_asset_location
        wo_items_asset_id
        wo_items_task_id
        wo_items_comment
        equipment_asset_id
        equipment_comment
        equipment_refrigerant_used
        equipment_type
        procedure_template_id
        procedure_asset_id
        procedure_type
        procedure_allow_mark_all
        procedure_allow_not_applicable
        procedure_is_not_applicable
        procedure_flag_id
        procedure_status_id
        procedure_index
        financial_items
        quote_items
        estimate_items
        action_logs
        last_action_date
        dt_created
        dt_due
        dt_acknowledge_by
        acknowledge_by_utc
        last_action_date_utc
        created_date_utc
        due_date_utc
        dt_on_site_by
        dt_utc_on_site_by
        last_action_id
        induction_and_safety_status_id
        concurrency_id
        owner_id
        evaluation_ids_while_open
        latest_evaluation_id_after_closed
        source_company_id
        note_text
        completion_note_text
        raw_workorder_response
        created_at
        updated_at
        property_number
        assignee_screen_name
        failure_code
        created_by_name
        subtype_name
        failure_category
        total_spot_cost
        is_dst
        root_comp
        source
        validation
        asset
        avoid
        property_uuid
        compressor_failure_detected
        compressor_failure_confidence
        compressor_failure_reasoning
        llm_last_analyzed
        llm_suggested_asset
        llm_suggested_validation
        llm_classification_confidence
        llm_classification_reasoning
    }
}`;

const CorrigoWorkOrderFilter = `
query CorrigoWorkOrderFilter($input: FilterConnectionInput) {
    corrigoWorkOrderFilter(input: $input) {
        pageInfo {
            endCursor
            startCursor
            hasNextPage
            hasPrevPage
            pageCount
            totalCount
            startIndex
            endIndex
        }
        edges {
            node {
                work_order_id
                id
                uuid
                number
                x_number
                type_category
                work_order_cost_id
                priority_id
                priority
                status_id
                requestor_contact_id
                access
                main_asset_id
                short_location
                task_refinement
                work_zone_id
                employee_id
                duration
                address_id
                bill_to_type
                bill_to_option_id
                vendor_nte_currency
                vendor_nte_value
                specialty_id
                po_number
                sub_type_id
                repair_code_id
                customer_id
                customer_nte_currency
                customer_nte_value
                billing_rule
                costs_total_value
                costs_total_currency
                vendor_invoice_total_value
                vendor_invoice_total_currency
                expenses_total_value
                expenses_total_currency
                service_fees_total_value
                service_fees_total_currency
                contact_name
                contact_address_id
                won_id
                dt_scheduled_start
                scheduled_start_utc
                is_warranty
                flag_id
                time_zone
                currency_type_id
                bill_status
                ap_state_id
                ap_status_id
                is_pre_billed
                cost_state
                cost_status_id
                job_code
                authorization_code
                check_number
                payment_amount_value
                payment_amount_currency
                payment_notes
                check_cut_date
                check_clear_date
                vendor_invoice_date
                vendor_invoice_received_date
                wo_items_sort_order_idx
                wo_items_asset_location
                wo_items_asset_id
                wo_items_task_id
                wo_items_comment
                equipment_asset_id
                equipment_comment
                equipment_refrigerant_used
                equipment_type
                procedure_template_id
                procedure_asset_id
                procedure_type
                procedure_allow_mark_all
                procedure_allow_not_applicable
                procedure_is_not_applicable
                procedure_flag_id
                procedure_status_id
                procedure_index
                financial_items
                quote_items
                estimate_items
                action_logs
                last_action_date
                dt_created
                dt_due
                dt_acknowledge_by
                acknowledge_by_utc
                last_action_date_utc
                created_date_utc
                due_date_utc
                dt_on_site_by
                dt_utc_on_site_by
                last_action_id
                induction_and_safety_status_id
                concurrency_id
                owner_id
                evaluation_ids_while_open
                latest_evaluation_id_after_closed
                source_company_id
                note_text
                completion_note_text
                raw_workorder_response
                created_at
                updated_at
                property_number
                assignee_screen_name
                failure_code
                created_by_name
                subtype_name
                failure_category
                total_spot_cost
                is_dst
                root_comp
                source
                asset
                validation
                avoid
                property_uuid
                compressor_failure_detected
                compressor_failure_confidence
                compressor_failure_reasoning
                llm_last_analyzed
                llm_suggested_asset
                llm_suggested_validation
                llm_classification_confidence
                llm_classification_reasoning
            }
        }
    }
}
`;

const GetWorkOrderIdsByDateRange = `
query GetWorkOrderIdsByDateRange($startDate: String!, $endDate: String!) {
    getWorkOrderIdsByDateRange(startDate: $startDate, endDate: $endDate)
}`;

const UpdateWorkOrderVal = `
mutation UpdateWorkOrderVal($work_order_id: ID!, $validation: Int!) {
    updateWorkOrderVal(work_order_id: $work_order_id, validation: $validation)
}`;

const UpdateWorkOrderAsset = `
mutation UpdateWorkOrderAsset($work_order_id: ID!, $asset: Int!) {
    updateWorkOrderAsset(work_order_id: $work_order_id, asset: $asset)
}`;

const UpdateWorkOrderAvoid = `
mutation UpdateWorkOrderAvoid($work_order_id: ID!, $avoid: Int!) {
    updateWorkOrderAvoid(work_order_id: $work_order_id, avoid: $avoid)
}`;

export default WorkOrders;